// Default WordPress JS

import 'bootstrap';

// AOS
import './inc/aos-init';

// Image Swap
import './inc/image-swap';

// Bootstrap Overrides
import './inc/bootstrap-overrides';

// Shrink Nav
import './inc/shrink-nav';

// Typed JS
import './inc/typed';
console.log('Main JS Loaded');



// WEBPACK FOOTER //
// ./src/js/main.js